import React, {Component, FC, ReactElement} from 'react';
import styled from 'styled-components';

type separatorProps = {
    height:string,
    anchorName:string,
    anchorTrigger:string
}

type separatorElementProps = {
    height:string
}


const SeparatorElement = styled.div<separatorElementProps>`
&.separator {
    height: ${props => props.height + 'px' || '10px'};
}
`;

const Separator: FC<separatorProps> = ({...props}): ReactElement => {

    return (
        <SeparatorElement className={"separator"} height={props.height}></SeparatorElement>
    )
}

export let settings:any;
let SettingsData;
const environmentLink:any = window.getEnvironmentLink();
try {
    SettingsData = require('../../../settings-data').default;
    // do stuff
} catch (ex) {
    SettingsData = null;
}
if(SettingsData) {
    const settingsClass = new SettingsData();
    const allSettings = settingsClass.getAllSettings();
    settings = [
        [//group
            {
                settingName: 'Size',
                isMainSettings: true,
                controls: [
                    {
                        controlName: 'Slider',
                        title: 'Size',
                        property: 'height',
                        defaultValue: 70,
                        suffix: 'px',
                        min: 5,
                        max: 350
                    }
                ],
            }
        ],
        [
            {
                settingName: 'Anchor',
            }
        ]
    ];
}

const options = [
    {
        name:'size',
        title: 'Size',
        icon: environmentLink + '/assets/images/Options/size.svg',
        action: 'setActiveSetting',
        settingTitle: 'Size'
    }
]
export default {
    Separator,
    settings,
    options,
    label: 'Spacer'
};



